import axios from "axios";
import store from "@/store";

import { firebaseAuth, loadFirebase } from '@/firebaseConfig'
import Router from '../router/index'
import family from '@/services/FamilyService'
import { panelToken } from '@/services/panelToken'

const loginEvent = 'freshToken'
const userRoleEvent = 'userRole'
const simpleModeEvent = 'simple_mode'


export default {
  async login2(payload) {
    await authClient.get("/sanctum/csrf-cookie");
    return authClient.post("/login", payload);
  },
  /*
   * The router asks this before every navigation, so it has to answer without
   * waiting for anything. It reads the token the login wrote - which is what it
   * always returned; the firebase.auth().currentUser it used to fetch first was
   * assigned to a variable and then ignored, at the cost of loading the whole
   * Firebase SDK on every page.
   */
  isUserLoggedIn() {
    const token = localStorage.getItem(loginEvent)

    /*
     * "undefined" is a stored token too.
     *
     * localStorage.setItem turns whatever it is given into a string, so a
     * token that came out undefined was saved as the six letters of the word
     * and read back as a perfectly good session - which is how the panel came
     * to draw the portal for somebody it could not authenticate.
     */
    return token != null && token != 'null' && token != 'undefined' && token != '';
  },
  /** Start fetching Firebase before it is needed, e.g. on the login screen. */
  warmUpFirebase() {
    return loadFirebase();
  },
  getLoggedInUserRole() {
    const userRole = localStorage.getItem(userRoleEvent)
    if (userRole == 1)
        return 'admin'
    else if (userRole == 2)
        return 'school'
    //a family signs in too now. A guardian is attached to children rather than
    //to a school, so both roles land on the same panel
    else if (userRole == 4 || userRole == 5)
        return 'parent'
    else
        return null
  },
  getMode() {
    const simple_mode = localStorage.getItem(simpleModeEvent)
    if (simple_mode == 1)
        return "simple"
    else
        return "advanced"
  },

  async login (payload) {
    /*
     * A stale session is not a reason to refuse a sign-in.
     *
     * This used to answer "you are already logged in" and push you to the
     * front page - so anybody whose session had gone bad, which is exactly
     * who reaches for the login screen, clicked Sign in and was returned to
     * the page they had just left, with no way through and nothing to
     * explain it. The old token is dropped and the sign-in goes ahead,
     * because opening the login screen and typing a password is not an
     * ambiguous request.
     */
    if (this.isUserLoggedIn()) {
      localStorage.setItem(loginEvent, null)
      localStorage.setItem(userRoleEvent, null)
      localStorage.setItem(simpleModeEvent, null)
      delete axios.defaults.headers.common['Authorization']
      family.forget()
    }
    // Try to sigin
    try {
      const auth = await firebaseAuth();
      var result = await auth.signInWithEmailAndPassword(payload.email, payload.password);
      var token = await result.user.getIdToken(true);
      await axios({
        method:'get',
        url:'sanctum/csrf-cookie',
        baseURL: '/backend',
       })
       .then(response => {
          console.log(response);
       })
       .catch(error => {
           console.log(error);
       });
      var response = await axios.post('/auth/loginViaToken', {
        'device_name': `${vm.$browserDetect.meta.name  }- v${  vm.$browserDetect.meta.version}`,
        token
      });
      let user = response.data.user_data
      const userRole = user.role_id

      /*
       * Who this panel is for: the platform's own admin, a school, and a
       * family - parent or guardian.
       *
       * The family was refused right here. Everything else had been built for
       * them - a login screen that knew where to send them, a panel, four
       * screens, a portal on the server - and this one line turned them away
       * at the door with "only admin accounts", which is not even true of the
       * school.
       *
       * Drivers and children are still refused, and told why: a driver has an
       * app that does what this cannot, and a child has no account at all.
       */
      if ([1, 2, 4, 5].indexOf(Number(userRole)) === -1)
      {
        const error = Error(
          Number(userRole) === 3
            ? "Drivers sign in on the driver app, not here."
            : "This account cannot be used to sign in here."
        );
        error.name = "Not for this panel";
        throw error;
      }
      const ourToken = response.data.token
      /*
       * A family's token has no pipe in it to split on - see panelToken. This
       * used to keep the half after the pipe for everybody, which handed a
       * parent the string "undefined" and signed them out one request later.
       */
      const freshToken = panelToken(ourToken)
      if (!freshToken) {
        const error = Error("The sign-in did not come back with a usable token.")
        error.name = "No token"
        throw error
      }
      const simple_mode = response.data.simple_mode
      localStorage.setItem(loginEvent, freshToken)
      localStorage.setItem(userRoleEvent, userRole)
      localStorage.setItem(simpleModeEvent, simple_mode)
      axios.defaults.headers.common['Authorization'] = `Bearer ${freshToken}`
      return user;
    } catch (error) {
      localStorage.setItem(loginEvent, null)
      localStorage.setItem(userRoleEvent, null)
      localStorage.setItem(simpleModeEvent, null)
      payload.notify({
        title: 'Error',
        text: error.message,
        type: 'error'
      })
        return null;
    }
  },

  async register (payload) {
    // If user is already logged in notify and exit
    if (this.isUserLoggedIn()) {
      payload.notify({
        title: 'Sign up Attempt',
        text: 'You are already logged in!',
        type: 'warning'
      })
      Router.push('/home').catch(() => {})
      return false
    }
    // Try to register
    try {
      const auth = await firebaseAuth();
      var result = await auth.createUserWithEmailAndPassword(payload.email, payload.password);
      var token = await result.user.getIdToken(true);
      var response = await axios.post('/auth/sign-up-via-token', {
        'device_name': `${vm.$browserDetect.meta.name  }- v${  vm.$browserDetect.meta.version}`,
         token,
        'role': 2,
        'name': payload.name,
        'email': payload.email,
        'g-recaptcha-response': payload.recaptcha
      });
      let user = response.data.user_data
      const userRole = user.role_id
      if (userRole != 1 && userRole != 2)
      {
        const error = Error(
          "Your account can not be used here! Only admin accounts."
        );
        error.name = "Not admin";
        throw error;
      }
      const ourToken = response.data.token
      const freshToken = panelToken(ourToken)
      const simple_mode = response.data.simple_mode
      localStorage.setItem(loginEvent, freshToken)
      localStorage.setItem(userRoleEvent, userRole)
      localStorage.setItem(simpleModeEvent, simple_mode)
      axios.defaults.headers.common['Authorization'] = `Bearer ${freshToken}`
      return user;
    } catch (error) {
      localStorage.setItem(loginEvent, null)
      localStorage.setItem(userRoleEvent, null)
      localStorage.setItem(simpleModeEvent, null)
      payload.notify({
        title: 'Error',
        text: error.message,
        type: 'error'
      })
        return null;
    }
  },

  async logout() {

    // if user is logged in via firebase
    const auth = await firebaseAuth();

    if (auth.currentUser) {
      await auth.signOut();
    }

    localStorage.setItem(loginEvent, null)
    localStorage.setItem(userRoleEvent, null)
    localStorage.setItem(simpleModeEvent, null)

    //the children of whoever was signed in, so the next person to use this
    //browser is not shown somebody else's family
    family.forget()

    // If user clicks on logout -> redirect
    Router.push('/home').catch(() => {})
  },
  logout2() {
    return authClient.post("/logout");
  },
  async forgotPassword(payload) {
    await authClient.get("/sanctum/csrf-cookie");
    return authClient.post("/forgot-password", payload);
  },
  getAuthUser() {
    return authClient.get("/api/users/auth");
  },
  async resetPassword(payload) {
    return axios
    .post('/auth/reset-password', {
      email: payload.email,
    });
  },
  updatePassword(payload) {
    return authClient.put("/user/password", payload);
  },
  async registerUser(payload) {
    await authClient.get("/sanctum/csrf-cookie");
    return authClient.post("/register", payload);
  },
  sendVerification(payload) {
    return authClient.post("/email/verification-notification", payload);
  },
  updateUser(payload) {
    return authClient.put("/user/profile-information", payload);
  },


  checkError(error, router, swal)
  {
    console.log(error)
    if(error.includes('Unauthenticated'))
    {
      this.logout();
      router.push({ name: 'login' });
    }
    else{
      swal("Error", error, "error");
    }
  }
};
